import { render, staticRenderFns } from "./FunnelSettings.vue?vue&type=template&id=5e85c2b0&scoped=true"
import script from "./FunnelSettings.vue?vue&type=script&lang=js"
export * from "./FunnelSettings.vue?vue&type=script&lang=js"
import style0 from "./FunnelSettings.vue?vue&type=style&index=0&id=5e85c2b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e85c2b0",
  null
  
)

export default component.exports